const basicColors = {
  primary: '#814F99',
  primaryHover: '#9663AE',
  primaryActive: '#5F3A71',
  primarySuperLight: '#814F9914',
  tabLabel: '#814F9914',
  menuHover: '#814F9914',
  menuActive: '#814F991F',
  /** Active background by menu level (lightest to strongest): L0 = top accordion, L1/L2 = nested accordions, menuActive = leaf. */
  menuActiveL0: '#814F9914',
  menuActiveL1: '#814F990C',
  menuActiveL2: '#814F9914',
  secondary: '#402C47',
  secondaryHover: '#573C60',
  secondaryActive: '#211724',
  tertiary: '#e11f57',
  error: '#d32f2f',
  warning: '#ef6c00',
  info: '#0288d1',
  white: '#fff',
  gray: '#e0e0e0',
  backgroundGray: '#F4F4FA',
  disabled: '#c6c9cf',
  muiBorder: '#c4c4c4',
  muiLabel: '#666768',
  menuLabel: '#212121',
  modalShadow: 'rgba(0, 0, 0, 0.25)',
  modalBackdrop: '#21172480',
  modalBackdropDark: '#211724',
  outlinedBorder: '#814F9940',
  black: '#000',
  addProductSectionTitle: '#787878',
  gray400: '#BDBDBD',
  icon: '#402C47CC'
}

export const theme = {
  colors: {
    primary: basicColors.primary,
    primaryHover: basicColors.primaryHover,
    primaryActive: basicColors.primaryActive,
    secondary: basicColors.secondary,
    secondaryHover: basicColors.secondaryHover,
    secondaryActive: basicColors.secondaryActive,
    tertiary: basicColors.tertiary,
    error: basicColors.error,
    warning: basicColors.warning,
    info: basicColors.info,
    white: basicColors.white,
    gray: basicColors.gray,
    background: basicColors.backgroundGray,
    disabled: basicColors.disabled,
    tabLabel: basicColors.tabLabel,
    menuHover: basicColors.menuHover,
    menuActive: basicColors.menuActive,
    menuActiveL0: basicColors.menuActiveL0,
    menuActiveL1: basicColors.menuActiveL1,
    menuActiveL2: basicColors.menuActiveL2,
    muiBorder: basicColors.muiBorder,
    muiLabel: basicColors.muiLabel,
    menuLabel: basicColors.menuLabel,
    modalShadow: basicColors.modalShadow,
    modalBackdrop: basicColors.modalBackdrop,
    modalBackdropDark: basicColors.modalBackdropDark,
    primarySuperLight: basicColors.primarySuperLight,
    outlinedBorder: basicColors.outlinedBorder,
    black: basicColors.black,
    addProductSectionTitle: basicColors.addProductSectionTitle,
    gray400: basicColors.gray400,
    icon: basicColors.icon,
    button: {
      primary: {
        background: basicColors.primary,
        hover: basicColors.primaryHover,
        action: basicColors.primaryActive,
        font: basicColors.white,
        disabled: {
          background: basicColors.gray,
          font: basicColors.white
        }
      },
      secondary: {
        background: basicColors.secondary,
        hover: basicColors.primary,
        action: basicColors.secondaryActive,
        font: basicColors.white,
        disabled: {
          background: basicColors.gray,
          font: basicColors.white
        }
      },
      outlined: {
        font: basicColors.primary,
        background: basicColors.white,
        border: `1px solid #814F991F`,
        hover: `#814F990A`,
        fontHover: basicColors.primary,
        action: `#814F991F`,
        boxShadow: `0 1px 2px 0 #21172480`,
        disabled: {
          background: basicColors.gray,
          font: basicColors.white
        }
      }
    }
  },
  gradients: {
    bottomLine: `linear-gradient(90deg, rgba(222,151,53,1) 0%, rgba(186,42,95,1) 50%, rgba(93,110,176,1) 100%);`,
    background: `linear-gradient(rgba(222,151,53, 0.2) 0%, rgba(186,42,95, 0.2) 50%, rgba(93,110,176, 0.2) 100%)`
  },
  typography: {
    fontFamily: `'Roboto', sans-serif`,
    fontSizeTitle: '24px',
    fontSizeBig: '18px',
    fontSizeNormal: '14px',
    fontSizeSmall: '12px',
    fontWeightBold: '700',
    fontWeightRegular: '400'
  },
  zIndex: {
    low: 50,
    medium: 100,
    height: 150,
    modal: 200,
    max: 1000
  },
  shadows: {
    menu: `10px 0 15px -8px #0000000A`,
    imageBackdrop: `4px 4px 4px 0 rgba(0, 0, 0, 0.25)`,
    navBar: `0 4px 4px -1px #21172440`,
    tooltip: `4px 4px 4px 0 rgba(0, 0, 0, 0.25)`
  },
  dimensions: {
    navBarHeight: 64,
    logoWhiteHeight: 44,
    logoColorHeight: 64
  }
}

export default theme
